import TokensService from '@omni/kit/services/TokensService';

import Environment from '../../../Environment';
import BaseService, {
  IFilter,
  IHttpResponse,
  IUri,
  buildUrl,
} from '../../BaseService';
import { IGroupHeadCounts } from '../Types';

const RESOURCE = 'headcounts';

interface IGetGroupHeadCounts extends Omit<IUri, 'resource'> {
  token?: string | null;
  filters: IFilter[];
}

interface IGetGroupHeadCountsResponse extends IHttpResponse {
  body?: IGroupHeadCounts;
}

export default async ({
  token,
  filters,
}: IGetGroupHeadCounts): Promise<IGetGroupHeadCountsResponse> => {
  const url = buildUrl({
    host: Environment.groupsHost,
    filters: filters,
    resource: RESOURCE,
  });

  const guestToken = await TokensService.getGuestToken();

  return BaseService.Get({
    url,
    token: token ? token : guestToken,
    skipTimestamp: true,
  });
};
